import React from "react";
import { Link, NavLink } from "react-router-dom";

const NavBar = ({ user ,pcode}) => {
  
  
  return (




    <nav className="navbar navbar-expand-lg navbar-light app-navbar">
      <Link className="navbar-brand" to="/">
        برنامج التفسير
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>
      <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div className="navbar-nav ">
        
          {!user && (
            <React.Fragment>
              <NavLink className="nav-item nav-link" to="/login">
                Login
              </NavLink>

           
            </React.Fragment>
          )}
          {user && pcode===999 && (
            <React.Fragment>
       
          
         {/* <NavLink className="nav-item nav-link" to="/dreamsDeleted" > 
            أحلام محذوفة
          </NavLink> */}

              <NavLink className="nav-item nav-link" to="/AdibApp">
                للمستشار أديب
              </NavLink>
          <NavLink className="nav-item nav-link" to="/dreamsSearch" target="_blank">
          بحث 
          </NavLink>
          <NavLink className="nav-item nav-link" to="/report" target="_blank">
          تقرير 
          </NavLink>
          <NavLink className="nav-item nav-link" to="/mobile" target="_blank">
          برنامج الموبايل
          </NavLink>
          
              
                <NavLink className="nav-item nav-link" to="/gpt" >
                GPT SMS
              </NavLink>
          <NavLink className="nav-item nav-link" to="/Keywords">
          الويب سيت 
          </NavLink>
              <NavLink className="nav-item nav-link" to="/profile">
                {user}
              </NavLink>
              <NavLink className="nav-item nav-link" to="/logout">
                Logout
              </NavLink>
            </React.Fragment>
          )}
      
{user && pcode===888 && (
  <React.Fragment>


 
<NavLink className="nav-item nav-link" to="/dreamsSearch" target="_blank">
بحث 
</NavLink>
 
<NavLink className="nav-item nav-link" to="/Keywords">
الويب سيت 
              </NavLink>
              <NavLink className="nav-item nav-link" to="/report" target="_blank">
          تقرير 
          </NavLink>
    <NavLink className="nav-item nav-link" to="/profile">
      {user}
    </NavLink>
    <NavLink className="nav-item nav-link" to="/logout">
      Logout
    </NavLink>
  </React.Fragment>
          )}
          {user && pcode===300 && (
  <React.Fragment>

 
 
<NavLink className="nav-item nav-link" to="/Keywords">
الويب سيت 
              </NavLink>
              <NavLink className="nav-item nav-link" to="/report" target="_blank">
          تقرير 
          </NavLink>
    <NavLink className="nav-item nav-link" to="/profile">
      {user}
    </NavLink>
    <NavLink className="nav-item nav-link" to="/logout">
      Logout
    </NavLink>
  </React.Fragment>
          )}
             {user && pcode===123 && (
  <React.Fragment>

 
<NavLink className="nav-item nav-link" to="/report" target="_blank">
          تقرير 
          </NavLink>
 
    <NavLink className="nav-item nav-link" to="/profile">
      {user}
    </NavLink>
    <NavLink className="nav-item nav-link" to="/logout">
      Logout
    </NavLink>
  </React.Fragment>
)}
</div>
</div>
</nav>
);
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/navBar.jsx